import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './form-switch.style'

const Switch = (props) => {
  const classes = useStyles(props)
  const { checked, id, name, onChange, value } = props

  return (
    <label className={classes.switchContainer}>
      <input
        checked={checked}
        className={classes.switchInput}
        id={id}
        name={name}
        onChange={onChange}
        type='checkbox'
        value={value}
      />
      <span className={classes.switchSlider} />
    </label>
  )
}

Switch.defaultProps = {
  checked: false,
  id: '',
  name: '',
  onChange: () => {},
  value: ''
}

Switch.propTypes = {
  checked: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

export default Switch
